<template>
  <e-menu-item @click="onClickItem" :uppercase="uppercase" :badge="badge" :icon="icon" :label="label" :link-class="linkClass" class="e-sub-menu e-menu__sub-menu" :class="menuItemClasses">
    <template slot="link-prepend">
      <slot name="link-prepend">
        <img v-if="icon" :src="getImg" class="e-menu__prepend"/>
      </slot>
    </template>
    <template slot="link-append">
      <div class="e-sub-menu__toggle"></div>
      <slot name="link-append"></slot>
    </template>
    <template slot="append">
      <e-menu class="e-sub-menu__list">
        <slot></slot>
      </e-menu>
    </template>
  </e-menu-item>
</template>

<script>
	import EMenuItem from "./menuItem";
	import EMenu from "./menu";

  export default {
		name: "e-submenu-item",
    components: {EMenuItem, EMenu},
    props: [
      'uppercase',
      'badge',
      'icon',
      'label',
      'linkClass',
      'parentOpen'
    ],
    watch: {
      parentOpen(v) {
		    this.parentIsOpen = v;
      }
    },
    methods: {
      onClickItem() {
        if(this.parentIsOpen) {
          this.isOpen = !this.isOpen;
        } else {
          this.isOpen = true;
          this.$emit('needOpen');
          console.log(123123);
        }
        this.$emit('click');
      }
    },
    data() {
		  return {
		    isOpen: this.$props.open || false,
        parentIsOpen: true,
      }
    },
    computed: {
      getImg() {
        return require(`../../../assets/icons/${this.icon}.svg`);
      },
      menuItemClasses() {
        return { 'is-open': this.isOpen && this.parentIsOpen, 'is-close': !this.isOpen || !this.parentIsOpen }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/sidebar/subMenuItem.vue